module.exports = __webpack_public_path__ + "static/media/2.722316cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/web/2.png
// module id = 2492
// module chunks = 0